module.exports = __webpack_public_path__ + "static/media/dog1.9db1dec7.jpeg";